const dashboardSection = $('#dashboard-section');
const dashboardCardTitles = dashboardSection.find('.dashboard-card-title');
const dashboardCardTexts = dashboardSection.find('.dashboard-card-text');
const dashboardCardProgress = dashboardSection.find('.dashboard-card-progress-status');
const dashboardBtn = dashboardSection.find('.button-parent');
const dashboardLotties = [];

const addProgressController = (loopTL) => {
  const progressControllers = dashboardSection.find('.dashboard-card-progress-controller');
  progressControllers.each(function () {
    $(this).on('click', function () {
      const id = $(this).attr('id').replace('controller-', '');
      loopTL.seek(`step${id}`);
    });
  });
};

const animateGraphCard = (graphIndex, duration) => {
  const lottieLength = dashboardLotties.length;
  const cardTL = gsap.timeline({ paused: true });
  const progressStart = (100 / lottieLength) * graphIndex;
  const progressEnd = (100 / lottieLength) * (graphIndex + 1);
  const prevIndex = (graphIndex - 1 + lottieLength) % lottieLength;
  const currentTitle = dashboardCardTitles.eq(graphIndex);
  const prevTitle = dashboardCardTitles.eq(prevIndex);
  const currentText = dashboardCardTexts.eq(graphIndex);
  const prevText = dashboardCardTexts.eq(prevIndex);
  cardEase1 = CustomEase.create('cardEase1', '0.00, 0.00, 0.20, 1.00');
  cardEase2 = CustomEase.create('cardEase2', '0.80, 0.00, 1.00, 1.00');

  cardTL.add(
    gsap.fromTo(
      dashboardCardProgress,
      {
        width: `${progressStart}%`,
      },
      {
        width: `${progressEnd}%`,
        duration: duration,
        ease: 'none',
      }
    ),
    0
  );

  cardTL.add(
    gsap.fromTo(
      prevTitle,
      {
        y: '0',
      },
      {
        y: '-1.875vw',
        duration: 0.667,
        ease: 'cardEase2',
      }
    ),
    0
  );

  cardTL.add(
    gsap.fromTo(
      prevTitle,
      {},
      {
        opacity: 0,
        duration: 0.5,
        ease: 'cardEase2',
      }
    ),
    0
  );

  cardTL.add(
    gsap.fromTo(
      currentTitle,
      {
        y: '2.5vw',
      },
      {
        y: 0,
        opacity: 1,
        duration: graphIndex == 0 ? 1 : 0.5,
        ease: 'cardEase1',
      }
    ),
    0.5
  );

  cardTL.add(
    gsap.fromTo(
      prevText,
      {
        y: '0',
      },
      {
        y: '-1.25vw',
        duration: 0.667,
        ease: 'cardEase2',
      }
    ),
    0
  );

  cardTL.add(
    gsap.fromTo(
      prevText,
      {},
      {
        opacity: 0,
        duration: 0.5,
        ease: 'cardEase2',
      }
    ),
    0
  );

  cardTL.add(
    gsap.fromTo(
      currentText,
      {
        y: '1.25vw',
      },
      {
        y: 0,
        opacity: 1,
        duration: graphIndex == 0 ? 1 : 0.5,
        ease: 'cardEase1',
      }
    ),
    0.5
  );

  if (graphIndex == 2) {
    cardTL.add(
      gsap.to(dashboardCardProgress, {
        x: '100%',
        duration: 0.5,
      }),
      duration
    );
    cardTL.add(
      gsap.to(currentTitle, {
        opacity: 0,
        duration: 0.5,
      }),
      duration
    );
    cardTL.add(
      gsap.to(currentText, {
        opacity: 0,
        duration: 0.5,
      }),
      duration
    );
  }

  return cardTL;
};

const animateGraphStep = (graphIndex, duration) => {
  const lottieLength = dashboardLotties.length;
  const prevIndex = (graphIndex - 1 + lottieLength) % lottieLength;
  const nextIndex = (graphIndex + 1) % lottieLength;
  const prevLottie = dashboardLotties[prevIndex];
  const currentLottie = dashboardLotties[graphIndex];
  const nextLottie = dashboardLotties[nextIndex];
  const stepTL = gsap.timeline({ paused: true });

  stepTL.add(() => {
    prevLottie.style.display = 'none';
    currentLottie.style.display = 'block';
    currentLottie.pause();
    currentLottie.currentTime = 0;
    currentLottie.play();
    currentLottie.addEventListener('complete', () => {
      nextLottie.pause();
      nextLottie.currentTime = 0;
    });
  });
  stepTL.to({}, { duration });

  if (graphIndex == dashboardLotties.length - 1) {
    stepTL.add(gsap.to('#fade-out', { opacity: 0, duration: 0.5 }));
  }

  return stepTL;
};

const animateGraphLoop = (duration) => {
  const loopTL = gsap.timeline({ paused: true, repeat: -1 });
  for (let i = 0; i < dashboardLotties.length; i++) {
    loopTL.addLabel(`step${i}`, duration * i);
    loopTL.add(animateGraphStep(i, duration).play(), `step${i}`);
    loopTL.add(animateGraphCard(i, duration).play(), `step${i}`);
  }

  return loopTL;
};

const addDashboardInAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };
  const dashboardCard = dashboardSection.find('.dashboard-card');
  const dashboardGraph = dashboardSection.find('.dashboard-graph-parent');

  const dashboardTL = gsap.timeline({ paused: true });

  dashboardTL.add(
    animateSectionTopperIn({
      sectionParent: dashboardSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );
  dashboardTL.add(addElementInAnimation(dashboardCard, '17.1%', 1, 0).play(), 0);
  dashboardTL.add(addElementInAnimation(dashboardGraph, '17.1%', 1, 0).play(), 0.3);
  return dashboardTL;
};


const addDashboardLottie = () => {
  const lottieSpeeds = [1.1851851852, 1, 1];
  const dashboardLottieContainers = dashboardSection.find('.dashboard-lottie-player');
  const dashboardInTL = isDesktop() ? addDashboardInAnimation() : false;

  dashboardLottieContainers.each(function (i) {
    const dashboardLottie = $(this).get(0);
    dashboardLottie.load();
    dashboardLottie.play().catch(() => dashboardLottie.pause());
    $(this).css('z-index', `${1000 - i}`);
    dashboardLotties.push(dashboardLottie);
    //dashboardLotties[i].setSpeed(lottieSpeeds[i]);
  });
  const loopTL = animateGraphLoop(8);

  ScrollTrigger.create({
    trigger: dashboardSection,
    start: 'top top+=120%',
    end: 'top top',
    once: true,
    onUpdate: (self) => {
      dashboardInTL ? dashboardInTL.progress(self.progress) : false;
    },
    onEnter: (self) => {
      loopTL.play();
      addProgressController(loopTL);
    },
  });
};

/*
$(window).on('heroReady', function () {
addDashboardLottie();
});
*/

addSectionObserver(dashboardSection, addDashboardLottie);